module.exports = __webpack_public_path__ + "ec417c9206b3bac056aff5d2fc7272f1.png";